import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import EmojiEventsIcon from './EmojiEventsIcon';
import CameraAlt from '@mui/icons-material/CameraAlt';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import Delete from '@mui/icons-material/Delete';
import Edit from '@mui/icons-material/Edit';
import Share from '@mui/icons-material/Share';

const make = (d: string) => (props: any) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d={d} />
  </SvgIcon>
);

export const HomeIcon = make('M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z');
export const MenuIcon = make('M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z');
export const SettingsIcon = make('M19.14,12.94c0.04-0.32,0.06-0.65,0.06-0.98s-0.02-0.66-0.06-0.98l2.03-1.58c0.18-0.14,0.23-0.4,0.12-0.6l-1.92-3.32c-0.11-0.2-0.36-0.28-0.57-0.22l-2.39,0.96c-0.5-0.38-1.05-0.7-1.66-0.94L14.5,2.5c-0.04-0.21-0.22-0.36-0.43-0.36h-3.14c-0.21,0-0.39,0.15-0.43,0.36L9.33,4.02c-0.61,0.24-1.17,0.56-1.66,0.94L5.28,4c-0.21-0.08-0.46,0.02-0.57,0.22L2.79,7.54c-0.11,0.2-0.06,0.46,0.12,0.6l2.03,1.58C4.9,11.34,4.88,11.67,4.88,12s0.02,0.66,0.06,0.98L2.91,14.56c-0.18,0.14-0.23,0.4-0.12,0.6l1.92,3.32c0.11,0.2,0.36,0.28,0.57,0.22l2.39-0.96c0.5,0.38,1.05,0.7,1.66,0.94l0.17,1.52c0.04,0.21,0.22,0.36,0.43,0.36h3.14c0.21,0,0.39-0.15,0.43-0.36l0.17-1.52c0.61-0.24,1.17-0.56,1.66-0.94l2.39,0.96c0.21,0.08,0.46-0.02,0.57-0.22l1.92-3.32c0.11-0.2,0.06-0.46-0.12-0.6L19.14,12.94z');
export const DeleteIcon = (props: any) => <Delete {...props} />;
export const EditIcon = (props: any) => <Edit {...props} />;
export const ShareIcon = (props: any) => <Share {...props} />;
export const CameraAltIcon = (props: any) => <CameraAlt {...props} />;
export const PhotoCameraIcon = (props: any) => <PhotoCamera {...props} />;
export const ArrowBackIcon = make('M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z');
export const PlayArrowIcon = make('M8 5v14l11-7z');
export const AddIcon = make('M19 13H13v6h-2v-6H5v-2h6V5h2v6h6v2z');
export const RemoveIcon = make('M19 13H5v-2h14v2z');
export const CloseIcon = make('M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z');
export const RefreshIcon = make('M17.65 6.35A7.95 7.95 0 0 0 12 4V1L8 5l4 4V6c2.76 0 5 2.24 5 5 0 .34-.04.67-.11.99l1.98 1.02C19.95 11.27 20 11 20 10c0-2.21-1.08-4.15-2.78-5.35z');
export const Visibility = make('M12 6a9.77 9.77 0 0 0-10 6 9.77 9.77 0 0 0 10 6 9.77 9.77 0 0 0 10-6 9.77 9.77 0 0 0-10-6zm0 10a4 4 0 1 1 0-8 4 4 0 0 1 0 8z');
export const VisibilityOff = make('M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5z');

export { default as EmojiEvents } from './EmojiEventsIcon';
export { default as EmojiEventsIcon } from './EmojiEventsIcon';

export default {
  HomeIcon,
  MenuIcon,
  SettingsIcon,
  DeleteIcon,
  EditIcon,
  ShareIcon,
  CameraAltIcon,
  PhotoCameraIcon,
  ArrowBackIcon,
  PlayArrowIcon,
  AddIcon,
  RemoveIcon,
  CloseIcon,
  RefreshIcon,
  Visibility,
  VisibilityOff,
  EmojiEventsIcon,
};
